import React from "react";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import { DASH } from "common/constants";

import useStyles from "./styles";

interface IProps {
  entries: racehorse360.HorseExamDetailObservationEntry[];
}

const ConditionNotes = ({ entries }: IProps) => {
  const classes = useStyles();

  if (!entries) return;

  const conditionNotes = entries.map(obs => obs.notes || DASH);

  return (
    <div className={classes.conditionNotes}>
      {conditionNotes.map((note, index, array) => (
        <React.Fragment key={index}>
          {note}
          {index !== array.length - 1 && <b> / </b>}
        </React.Fragment>
      ))}
    </div>
  );
};

export default React.memo(ConditionNotes);
